import { render, staticRenderFns } from "./RecoverMain.vue?vue&type=template&id=d0e722d0&scoped=true"
import script from "./RecoverMain.vue?vue&type=script&lang=ts"
export * from "./RecoverMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e722d0",
  null
  
)

export default component.exports